import { api } from '@/core/api/';

const URL = 'api/provider/endterm';
const URL_CODE = 'api/code/';
const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const searchGroup = (payload) =>
  api.get(`${URL}/searchGroup`, {
    params: {
      ...payload,
    },
  });

export const getEndtermDocumentTypes = () =>
  api.get(`${URL_CODE}endtermdocumenttypes`);

export const saveDocument = (payload) =>
  api.post(`${URL}/document/save`, payload, header);

export const getEndtermDocumentSaved = (payload) =>
  api.get(`${URL}/documents`, {
    params: {
      ...payload,
    },
  });
export const deleteBDocument = (documentId) => {
  return api.delete(`${URL}/document/delete/${documentId}`);
};

export const finalizeperiod = (payload) =>
  api.post(`${URL}/finalizeperiod`, payload);

export const getVisitsErrors = (visitsIds) =>
  api.get(`${URL}/visitserrors`, {
    params: visitsIds
      ? [...visitsIds].map((x) => new Object({ visitsIds: x }))
      : [],
    paramsSerializer: (params) =>
      params.map((obj) => new URLSearchParams(obj)).join('&'),
  });

export const getEndtermFinalizedPeriodStatus = (payload) =>
  api.get(`${URL}/finalizedperiodstatus`, {
    params: {
      ...payload,
    },
  });
